// General errors
export const ERROR_INVALID_REQUEST = 4051;

// Signup Errors
export const ERROR_SIGNUP_EXISTING_EMAIL = 4034;
export const ERROR_SIGNUP_FB_EXISTING_ACCOUNT = 4033;
export const ERROR_SIGNUP_FB_MISSING_EMAIL = 40331;

// Authentication Errors
export const ERROR_PASSWORD_RESET_REQUIRED = 4030;
export const ERROR_INVALID_CREDENTIALS = 4031;
export const ERROR_DID_NOT_SIGNUP_VIA_FACEBOOK = 4032;
export const ERROR_INVALID_PASSWORD_RESET_TOKEN = 4037;
export const ERROR_PASSWORD_MUST_BE_UNIQUE = 4043;
export const ERROR_CURRENT_PASSWORD_INVALID = 4045;
export const ERROR_PASSWORD_RESET_REQUIRES_CONSENT = 4046;

// Payment Errors
export const ERROR_PAYMENT = 4301;

// Reservation Errors
export const ERROR_RESERVATION_NO_SPOTS = 5011;
export const ERROR_RESERVATION_WINDOW_CLOSED = 5421;

// Gift Code Errors
export const ERROR_INVALID_GIFT_CODE = 4350;
export const ERROR_GIFT_CODE_ALREADY_REDEEMED = 4351;

// Bundle Purchase Errors
export const ERROR_BUNDLE_PURCHASE_FAILED = 5371; // Generic bundle error. Ex: bundles service can't reach Stripe API
export const ERROR_BUNDLE_PURCHASE_DECLINED = 5372; // Raised when Stripe bounces a purchase
